var _mask, _path, _path2, _path3, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPedalLeftPressed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 138,
    viewBox: "0 0 60 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3472_1448",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.92935C0 1.31152 1.31151 0 2.92935 0H57.0707C58.6885 0 60 1.31151 60 2.92935V135.071C60 136.688 58.6885 138 57.0707 138H2.92935C1.31151 138 0 136.688 0 135.071V2.92935Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.92935C0 1.31152 1.31151 0 2.92935 0H57.0707C58.6885 0 60 1.31151 60 2.92935V135.071C60 136.688 58.6885 138 57.0707 138H2.92935C1.31151 138 0 136.688 0 135.071V2.92935Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92935 0V1H57.0707V0V-1H2.92935V0ZM60 2.92935H59V135.071H60H61V2.92935H60ZM57.0707 138V137H2.92935V138V139H57.0707V138ZM0 135.071H1V2.92935H0H-1V135.071H0ZM2.92935 138V137C1.8638 137 1 136.136 1 135.071H0H-1C-1 137.241 0.759229 139 2.92935 139V138ZM60 135.071H59C59 136.136 58.1362 137 57.0707 137V138V139C59.2408 139 61 137.241 61 135.071H60ZM57.0707 0V1C58.1362 1 59 1.8638 59 2.92935H60H61C61 0.759229 59.2408 -1 57.0707 -1V0ZM2.92935 0V-1C0.759228 -1 -1 0.759234 -1 2.92935H0H1C1 1.8638 1.8638 1 2.92935 1V0Z",
    fill: "#7D7D7D",
    mask: "url(#path-1-inside-1_3472_1448)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 113V89H28.9542V108.816H39V113H24Z",
    fill: "#7D7D7D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 48,
    height: 14,
    fill: "#969696"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26,
    width: 48,
    height: 14,
    fill: "#969696"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 46,
    width: 48,
    height: 14,
    fill: "#969696"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedalLeftPressed);
export default __webpack_public_path__ + "static/media/pedal-left-pressed.378548d632c80657900546ccf41d62ad.svg";
export { ForwardRef as ReactComponent };